/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerListKeysQueryResponse, ServiceAccountsControllerListKeysPathParams, ServiceAccountsControllerListKeysQueryParams, ServiceAccountsControllerListKeys401, ServiceAccountsControllerListKeys403 } from "../../models/serviceAccountsController/ServiceAccountsControllerListKeys";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { serviceAccountsControllerListKeys } from "../../clients/service-accountsService/serviceAccountsControllerListKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const serviceAccountsControllerListKeysQueryKey = (orgId: ServiceAccountsControllerListKeysPathParams["orgId"], params: ServiceAccountsControllerListKeysQueryParams = {}) => [{
  url: '/api/v1/organizations/:orgId/api-keys',
  params: {
    orgId: orgId
  }
}, ...(params ? [params] : [])] as const;
export type ServiceAccountsControllerListKeysQueryKey = ReturnType<typeof serviceAccountsControllerListKeysQueryKey>;
export function serviceAccountsControllerListKeysQueryOptions(orgId: ServiceAccountsControllerListKeysPathParams["orgId"], params?: ServiceAccountsControllerListKeysQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = serviceAccountsControllerListKeysQueryKey(orgId, params);
  return queryOptions<ServiceAccountsControllerListKeysQueryResponse, ResponseErrorConfig<ServiceAccountsControllerListKeys401 | ServiceAccountsControllerListKeys403>, ServiceAccountsControllerListKeysQueryResponse, typeof queryKey>({
    enabled: !!orgId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return serviceAccountsControllerListKeys(orgId, params, config);
    }
  });
}

/**
 * @summary List active service account keys
 * {@link /api/v1/organizations/:orgId/api-keys}
 */
export function useServiceAccountsControllerListKeys<TData = ServiceAccountsControllerListKeysQueryResponse, TQueryData = ServiceAccountsControllerListKeysQueryResponse, TQueryKey extends QueryKey = ServiceAccountsControllerListKeysQueryKey>(orgId: ServiceAccountsControllerListKeysPathParams["orgId"], params?: ServiceAccountsControllerListKeysQueryParams, options: {
  query?: Partial<QueryObserverOptions<ServiceAccountsControllerListKeysQueryResponse, ResponseErrorConfig<ServiceAccountsControllerListKeys401 | ServiceAccountsControllerListKeys403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? serviceAccountsControllerListKeysQueryKey(orgId, params);
  const query = useQuery({
    ...serviceAccountsControllerListKeysQueryOptions(orgId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ServiceAccountsControllerListKeys401 | ServiceAccountsControllerListKeys403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}